/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const FacebookSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.1em"
    height="1.1em"
    version="1.1"
    viewBox="0 0 670 670"
  >
    <defs>
      <clipPath id="clipPath25" clipPathUnits="userSpaceOnUse">
        <path d="M0 700h700V0H0z"></path>
      </clipPath>
    </defs>
    <g transform="matrix(1.33333 0 0 -1.33333 -133.333 800)">
      <g>
        <g clipPath="url(#clipPath25)">
          <g transform="translate(600 350)">
            <path
              fill="#0866ff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M0 0c0 138.071-111.929 250-250 250S-500 138.071-500 0c0-117.245 80.715-215.622 189.606-242.638v166.242h-51.552V0h51.552v32.919c0 85.092 38.508 124.532 122.048 124.532 15.838 0 43.167-3.105 54.347-6.211V81.986c-5.901.621-16.149.932-28.882.932-40.993 0-56.832-15.528-56.832-55.9V0h81.659l-14.028-76.396h-67.631v-171.773C-95.927-233.218 0-127.818 0 0"
            ></path>
          </g>
          <g transform="translate(447.918 273.604)">
            <path
              fill="#fff"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M0 0l14.029 76.396H-67.63v27.019c0 40.372 15.838 55.899 56.831 55.899 12.733 0 22.981-.31 28.882-.931v69.253c-11.18 3.106-38.509 6.212-54.347 6.212-83.539 0-122.048-39.441-122.048-124.533V76.396h-51.552V0h51.552v-166.242a250.559 250.559 0 0160.394-7.362c10.254 0 20.358.632 30.288 1.831V0z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const FacebookIcon = (props) => (
  <Icon component={FacebookSvg} {...props} />
);
